module.exports = "{{$parent.row['score'] | number : 2}}\n"